'use client';

import { Box, SimpleGrid, Text, ThemeIcon, Title } from '@mantine/core';
import { useInViewport } from '@mantine/hooks';
import Animation from '@/app/components/animation/Animation';
import { changesData, FeatureProps } from '@/app/components/main/data';
import { useTranslation } from '@/i18n/client';
import classes from './Changes.module.css';

export function Feature({ icon: Icon, title, description }: FeatureProps) {
  const { t } = useTranslation('main');
  return (
    <div>
      <ThemeIcon variant='light' size={52} radius={52}>
        <Icon size={30} stroke={1.5} />
      </ThemeIcon>
      <Text mt='sm' c='white' mb={7} className={classes.cardTitle}>
        {t(title)}
      </Text>
      <Text lh={1.6} className={classes.cardDescription}>
        {t(description)}
      </Text>
    </div>
  );
}

export function Changes() {
  const viewPort = useInViewport();
  const { t } = useTranslation('main');
  const features = changesData.map((feature, index) => <Feature {...feature} key={index} />);

  return (
    <Box className={classes.wrapper}>
      <Box ref={viewPort.ref} style={{ position: 'relative', top: '450px' }} />
      <Animation transition='pop' duration={600} delay={200} inViewport={viewPort.inViewport}>
        <Box className={classes.inner}>
          <Title order={2} className={classes.title} ta='center' mt='sm'>
            {t('content.changes.title')}
          </Title>

          <Text className={classes.description} ta='center' mt='md'>
            {t('content.changes.description')}
          </Text>

          <SimpleGrid cols={{ base: 1, xs: 2, md: 3 }} spacing={50} mt={30}>
            {features}
          </SimpleGrid>
        </Box>
      </Animation>
    </Box>
  );
}

export default Changes;
